"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Public2 = _interopRequireDefault(require("@mui/icons-material/Public"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Tooltip2 = _interopRequireDefault(require("@mui/material/Tooltip"));
var _IconButton2 = _interopRequireDefault(require("@mui/material/IconButton"));
var _Close2 = _interopRequireDefault(require("@mui/icons-material/Close"));
var _styles = require("@mui/material/styles");
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _components = require("../../components");
var _models = require("../../models");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ParkingPopup(_ref) {
  let {
    theme,
    parking: {
      capacity,
      sheltered,
      supervised,
      locked,
      free,
      network: networkKey,
      website,
      id
    },
    onClose,
    onSelect
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const network = networkKey && _models.parkingNetworks[networkKey] || null;
  return /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(Wrapper, null, /*#__PURE__*/_react.default.createElement(CloseButtonWrapper, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "left",
    title: t('commons.actions.close')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    onClick: () => onClose(),
    size: "small"
  }, /*#__PURE__*/_react.default.createElement(_Close2.default, null)))), /*#__PURE__*/_react.default.createElement(StyledHeader, null, network && /*#__PURE__*/_react.default.createElement(StyledHeaderLogo, {
    title: network.title,
    url: network.icon
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    variant: "h6"
  }, t('commons.poi.categories.parking_one')), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexWrap: "wrap"
  }, capacity && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.racks', {
    count: capacity,
    capacity
  }), " \xA0\u2022\xA0")), locked && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.locked'), " \xA0\u2022\xA0"), sheltered && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.sheltered'), " \xA0\u2022\xA0"), supervised && /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t('commons.parking.supervised'), " \xA0\u2022\xA0"), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    noWrap: true,
    color: "textSecondary",
    component: "span",
    variant: "caption"
  }, t(free ? 'commons.parking.free' : 'commons.parking.toll'))))), website && /*#__PURE__*/_react.default.createElement(StyledActions, null, /*#__PURE__*/_react.default.createElement(_Tooltip2.default, {
    placement: "right",
    title: t('commons.website')
  }, /*#__PURE__*/_react.default.createElement(_IconButton2.default, {
    color: "primary",
    component: "a",
    href: website,
    rel: "noreferrer",
    size: "small",
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Public2.default, null)))), onSelect && /*#__PURE__*/_react.default.createElement(StyledActions, {
    style: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_components.Button, {
    color: "primary",
    onClick: () => onSelect(id),
    size: "small"
  }, t('commons.actions.select')))));
}
const Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  position: relative;
  width: min(100vw - 120px, 350px);
`;
const CloseButtonWrapper = _styledComponents.default.div`
  padding: 8px;
  position: absolute;
  right: 0;
  top: 0;

  button {
    background-color: rgba(255, 255, 255, 0.9);

    &:hover {
      background-color: rgba(255, 255, 255, 0.8);
    }
  }
`;
const StyledHeader = _styledComponents.default.div`
  display: flex;
  flex-shrink: 0;
  padding: 16px 54px 8px 16px;
`;
const StyledHeaderLogo = _styledComponents.default.div`
  align-self: center;
  background-image: ${_ref2 => {
  let {
    url
  } = _ref2;
  return `url(${url})`;
}};
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  height: 48px;
  margin-right: 8px;
  width: 48px;
`;
const StyledActions = _styledComponents.default.div`
  flex-shrink: 0;
  padding: 0 16px 8px;

  button {
    margin-left: 8px;
  }
`;
var _default = exports.default = ParkingPopup;